import { FC, ReactElement } from 'react';

import { signInWithRedirect } from 'aws-amplify/auth';
import clsx from 'clsx';

import { ReactComponent as FacebookIcon } from 'assets/icons/FacebookIcon.svg';
import { ReactComponent as GoogleIcon } from 'assets/icons/GoogleIcon.svg';

import { ISocialProviders, SOCIAL_PROVIDERS } from 'interfaces/auth';

import { Button } from 'components/_basic/Button/Button';

import ToastService from 'helpers/ToastService';

import { ISocialButtonsProps as IProps, ISocialButton } from './types';

import styles from './SocialButtons.module.scss';

export const SocialButtons: FC<IProps> = ({ googleTitle, facebookTitle }) => {
  const buttonsContent: ISocialButton[] = [
    {
      title: facebookTitle,
      icon: <FacebookIcon className={styles.icon} />,
      provider: SOCIAL_PROVIDERS.FACEBOOK,
    },
    {
      title: googleTitle,
      icon: <GoogleIcon className={styles.icon} />,
      provider: SOCIAL_PROVIDERS.GOOGLE,
    },
  ];

  const signInWithProvider = async (provider: ISocialProviders): Promise<void> => {
    try {
      await signInWithRedirect({ provider });
    } catch (error) {
      if (error instanceof Error) {
        ToastService.showError(error.message);
      }
    }
  };

  return (
    <>
      {buttonsContent.map(
        ({ title, icon, provider }): ReactElement => (
          <Button
            fullWidth
            key={provider}
            //TODO remove disabled after client connects his facebook account to prod
            className={clsx(styles.socialProviderButton, title.includes('Facebook') && styles.disabled)}
            onClick={() => title.includes('Facebook') ? null : signInWithProvider(provider)}
            variant="outlined"
          >
            {icon}
            {title}
          </Button>
        ),
      )}
    </>
  );
};
